import { render, staticRenderFns } from "./OfficialHolidayInfo.vue?vue&type=template&id=a3462ce6&scoped=true&"
import script from "./OfficialHolidayInfo.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidayInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3462ce6",
  null
  
)

export default component.exports